module.exports = __webpack_public_path__ + "static/media/hex-logo.268e1fc4.svg";